import { request } from '@/utils'

export default {
  getOutGoodsList: (params: PageParams) =>
    request.post(`/warehouse/outGoods/list?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}`, params.body || {}),
  getOutGoodInfoById: (id: string) => request.get(`/warehouse/outGoods/get/${id}`),
  confirmOut: (data: any) => request.post('/warehouse/outGoods/sureGoodsOut', data),
  revert: (data: { id: string }) => request.post('/warehouse/outGoods/cancelGoodsOut', data),
  getDirectionByCode: (code: string) => request.get(`/system/diction/findByCode/${code}`),
  getCategoryCascade: () => request.get('/purchase/purchase/supply/service/type/categoryCascadeQuery'),
  getBrandCascade: () => request.get('/purchase/purchase/supply/service/type/brandCascadeQuery'),
  getAllType: (type: string) => request.get(`/purchase/purchase/materials/getAllType?goodsCategory=${type}`),
  sureGoodsOutBatch: (data: any) => request.post(`/warehouse/outGoods/sureGoodsOutBatch`, data),
  exportExcel: (body: any) => request.post('/warehouse/outGoods/exportExcel', body, { responseType: 'blob' }),
}
